import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { SpeedInsights } from "@vercel/speed-insights/react"

// Global error handler for GSAP/React DOM conflicts
if (typeof window !== "undefined") {
  let logged = false;
  window.addEventListener("error", (e) => {
    if (e.message && (e.message.includes("removeChild") || e.message.includes("NotFoundError"))) {
      if (!logged) {
        console.warn("GSAP DOM node error prevented:", e.message);
        logged = true;
      }
      e.stopImmediatePropagation();
    }
  }, true);
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
    <SpeedInsights />
  </StrictMode>,
)
